import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { Link, navigate, RouteComponentProps } from '@reach/router';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import logMessages from '../Tasks/UserProfile/Messages';
import { ContentContainer, LayoutContainer } from 'utils/style/extendable';
import { IProviders, RootState } from 'store/store';
import {
  getMyProviders,
  getCompanyManagers,
  requireDocumentInFolder,
  getMyProvidersFn,
  getCompanyManagersFn,
  requireDocumentInFolderFn,
} from 'store/providers/providerSlice';
import folderPanel from 'assets/images/folderPanel.png';
import tasks from 'assets/images/schedule.png';
import pdp from 'assets/images/graduate.png';
import image from 'assets/images/empty-company2.png';
import prompt from 'assets/images/camp412-1.jpg';
import prompt2 from 'assets/images/camp412-2.jpg';
import prompt3 from 'assets/images/camp412-3.jpg';
import staffTraining from 'assets/images/Stuff-training.jpg';
import itWebinar from 'assets/images/it-webinar.jpg';
import rastech1402 from 'assets/images/rastech-1402.jpg';
import rastechSat from 'assets/images/rastech-sat.jpg';
import nabetasadof from 'assets/images/nabetasadof.jpg';
import {
  Card,
  Logo,
  Item,
  ItemWrapper,
  Avatar,
  Contents,
  ItemName,
  Container,
  ItemsList,
  CardHeader,
  CompanyItem,
  CompanyItemHead,
  CompanyItemBody,
  CompanySettings,
  LoginWarnInfo,
  LogItem,
} from './styles';
import Icon from 'components/Icon';
import logo from '../../assets/images/rastech-with-type.png';
import { display } from 'components/ErrorView/ErrorDialog';
import protectedRoute from 'components/protectedRoute';
import MainHeader from 'components/MainHeader';
import notify from '../../components/Notify';
import { myLoginActivity } from 'api/MakhsanApi';
import { IUserSecurityEvent, LogType } from 'store/entity/IUserSecurityEvent';
import { smartDateString } from 'utils/date';
import Button from 'components/Button/Button';
import { getDomainAndPort } from 'api/Utils';
import { red, stringToColour } from 'utils/style/colors';
import Modal from 'components/Modal';
import Input from 'components/Input/Input';
import Badge from 'components/Badge';
import { convertDigitToProperFormat } from 'utils/number';
import {
  HintIcon,
  HintText,
} from 'components/FileManager/ItemsViewer/Survey/SurveyEditor/GeneralQuestion/styles';
import { appDispatch } from 'store/store';
import {
  getMyCompanies,
  getMyCompaniesFn,
} from 'store/companies/companiesSlice';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import { ICompany, ICompanyState } from 'store/companies/companiesTypes';
import { IUser } from 'store/users/usersType';
import {
  IProvider,
  IProviderItemView,
  IProviderItemViewWithData,
} from 'store/providers/providerTypes';
import { isCompanyAdmin } from 'store/companies/companiesUtils';
import moment from 'moment-jalaali';
import { languageDirection } from '../../i18n';
import i18n from 'i18next';
import AddToHomeScreenPrompt from '../../components/Promps/AddToHomeScreenPrompt';
import {
  IUserInfo,
  makhsanSelfUserInfo,
} from '../../store/makhsanUserInfo/makhsanUserInfoSlice';

type StateToProps = {
  user: IUser;
  thisUser: IThisUserState;
  userId: number;
  companies: ICompanyState;
  providers: IProviders;
  state: RootState;
};

type DispatchToProps = {
  getMyCompanies: () => ReturnType<typeof getMyCompaniesFn>;
  getMyProviders: () => ReturnType<typeof getMyProvidersFn>;
  getCompanyManagers: (
    companyId: number
  ) => ReturnType<typeof getCompanyManagersFn>;
  getDocumentsInFolder: (
    folderId: number,
    providerId: number
  ) => ReturnType<typeof requireDocumentInFolderFn>;
};

export interface OldHomeProps {
  noCompanyText?: string;
  noCompanyLink?: string;
  noCompanyLinkTitle?: string;
}
interface OwnProps {
  homeDomainProps?: OldHomeProps;
}
type ComponentProps = OwnProps &
  RouteComponentProps &
  StateToProps &
  DispatchToProps;

interface IComponentState {
  lastFailedLogin: IUserSecurityEvent | undefined;
  hidePrompt: boolean;
  dontShowThisMessageAgain: boolean;
  dontShowTimeZoneError: boolean;
  offline: boolean;
  documentItems: IProviderItemView[];
  userPasswordStatus?: boolean;
}

export const promptLink = 'https://rstk.ir/insta';
interface PromptInfo {
  actionTitle?: string;
  key: string;
  endDate: number;
  startDate: number;
  showOnce: boolean;
  image?: any;
  link: string;
  description?: string;
}
const promptList: PromptInfo[] = [
  {
    key: 'camp412-1',
    endDate: 1709000522838,
    startDate: 170906580000,
    showOnce: false,
    image: prompt,
    link: 'https://rstk.ir/insta',
  },
  {
    key: 'camp412-2',
    endDate: 1709086936211,
    startDate: 1709000522838,
    showOnce: false,
    image: prompt2,
    link: 'https://rstk.ir/insta',
  },
  {
    key: 'camp412-3',
    endDate: 1709173336211,
    startDate: 1709086936212,
    showOnce: false,
    image: prompt3,
    link: 'https://rstk.ir/insta',
  },
  {
    key: 'campUserTrain',
    endDate: 1716669000000,
    startDate: 1705656900441,
    showOnce: false,
    image: staffTraining,
    link: 'https://rastech.health/fa/request-demo',
  },
  {
    key: 'mohammad',
    endDate: 1717273800000,
    startDate: 1705656900441,
    showOnce: false,
    image: itWebinar,
    link: 'https://rstk.ir/webinar-register',
  },
  {
    key: '1402',
    startDate: 1719915691955,
    endDate: 1720557000000,
    showOnce: false,
    image: rastech1402,
    link: 'https://rstk.ir/Performance-Report',
  },
  {
    key: 'sat-1403',
    startDate: 1739946529075,
    endDate: 1741178060245,
    showOnce: false,
    image: rastechSat,
    link: 'https://rstk.ir/sat',
  },
  {
    key: 'nabetasadof',
    startDate: 1741178060245,
    endDate: 1743280200000,
    showOnce: false,
    image: nabetasadof,
    link: 'https://nabetasadof.ir/',
  },
];

const satisficationSeasonRange = [
  {
    monthNumber: 2,
    dayRange: {
      start: 8,
      end: 18,
    },
  },
  {
    monthNumber: 5,
    dayRange: {
      start: 21,
      end: 31,
    },
  },
  {
    monthNumber: 8,
    dayRange: {
      start: 20,
      end: 30,
    },
  },
  {
    monthNumber: 11,
    dayRange: {
      start: 20,
      end: 30,
    },
  },
];

class oldHomePage extends React.PureComponent<ComponentProps, IComponentState> {
  constructor(props: ComponentProps) {
    super(props);
    this.state = {
      lastFailedLogin: undefined,
      hidePrompt: false,
      dontShowThisMessageAgain: false,
      dontShowTimeZoneError: false,
      offline: false,
      documentItems: [],
      userPasswordStatus: undefined,
    };
  }

  handleFetchLogin = () => {
    myLoginActivity(this.props.state).then((result) => {
      const failed = result.data.filter(
        (log, index) =>
          index < 5 &&
          (log.type === LogType.Unsuccessful_Authenticate_2FA ||
            log.type === LogType.Unsuccessful_Authenticate_Mobile ||
            log.type === LogType.Unsuccessful_Authenticate_Pass ||
            log.type === LogType.Unsuccessful_Authenticate_SAC) &&
          log.date > new Date().getTime() - 10 * 60 * 60 * 24 * 1000
      );
      if (failed.length > 0) this.setState({ lastFailedLogin: failed[0] });
    });
  };
  componentDidMount() {
    this.mountActions();
  }

  private mountActions() {
    const domainAndPort = getDomainAndPort();
    if (
      domainAndPort.domainFeatures &&
      domainAndPort.domainFeatures.forceHome
    ) {
      navigate(domainAndPort.domainFeatures.forceHome);
      return;
    }
    this.handleFetchLogin();
    this.props
      .getMyCompanies()
      .then(({ companies }) => {
        companies.forEach((company: ICompany) => {
          this.props
            .getCompanyManagers(company.id)
            .then(({ providers }: { providers: IProvider[] }) => {
              providers.forEach((p: IProvider) => {
                const rootDocument = p.rootDocument;
                if (rootDocument === null) return;
                const rootFolderId = rootDocument.id;
                const providerId = p.id;
                if (rootFolderId && providerId)
                  this.props
                    .getDocumentsInFolder(rootFolderId, providerId)
                    .then(null)
                    .catch((e) => {
                      if (e.data?.messsage) {
                        notify(e.data.messsage);
                      }
                    });
              });
            });
        });
      })
      .catch((err) => {
        this.setState({ offline: true });
        display(err);
      });
    this.props.getMyProviders().catch((err) => {
      display(err);
    });
    appDispatch(makhsanSelfUserInfo({ userId: this.props.userId })).then(
      (e: { userInfos: IUserInfo[] }) => {
        this.setState({
          userPasswordStatus:
            localStorage.getItem('setPassword') === 'true' ||
            e.userInfos[0]?.hasPassword,
        });
      }
    );
  }

  handleChangeRoute = (route: string) => () => {
    navigate(route);
  };

  preventPrompt = (key: string) => {
    localStorage.setItem(key, 'true');
  };

  render() {
    const { userId, companies, providers, user, thisUser, homeDomainProps } =
      this.props;
    const {
      lastFailedLogin,
      hidePrompt,
      dontShowThisMessageAgain,
      dontShowTimeZoneError,
    } = this.state;

    const hasProvider = !!thisUser.provider.id;
    const now = new Date().getTime();
    let promptInfo = promptList.find((it) => {
      return (
        it.startDate < now &&
        it.endDate > now &&
        localStorage.getItem(it.key) !== 'true'
      );
    });
    if (this.state.userPasswordStatus === false) {
      promptInfo = {
        key: 'setPassword',
        link: '/c/profile#password',
        description: i18n.t('setPasswordPrompt', {
          ns: 'general',
        }) as string,
        endDate: 0,
        startDate: 0,
        showOnce: false,
        actionTitle: 'ثبت کلمه عبور',
      };
    }
    const timeZoneError = new Date().getTimezoneOffset() !== -210;

    if (!promptInfo) {
      const currentMonth = moment(now).jMonth();
      const currentDate = moment(now).jDate();
      const isSatisPopupNotification = satisficationSeasonRange.find((item) => {
        return (
          item.monthNumber === currentMonth &&
          currentDate >= item.dayRange.start &&
          currentDate <= item.dayRange.end
        );
      });
      const currentYear = moment(now).jYear();
      const satKey = `${currentYear}-${currentMonth}`;
      const disableShowAgain = localStorage.getItem(satKey) === 'true';
      if (isSatisPopupNotification && !disableShowAgain) {
        promptInfo = {
          key: satKey,
          startDate: moment()
            .valueOf()
            // .jYear(currentYear)
            // .jMonth(isPopupNotification.monthNumber)
            // .jDate(isPopupNotification.dayRange.start)
            // .toDate()
            .valueOf(),
          endDate: moment().valueOf(),
          // .jYear(currentYear)
          // .jMonth(isPopupNotification.monthNumber)
          // .jDate(isPopupNotification.dayRange.end)
          // .toDate()
          // .valueOf(),
          showOnce: false,
          image: rastechSat, // need to be change
          link: 'https://rstk.ir/sat',
        };
      }
    }

    return (
      <LayoutContainer>
        {promptInfo && promptInfo.image !== '' && (
          <Modal
            width="unset"
            title={''}
            onClose={() => {
              if (
                (dontShowThisMessageAgain || promptInfo?.showOnce) &&
                promptInfo?.key
              )
                this.preventPrompt(promptInfo.key);
              this.setState({ hidePrompt: true });
            }}
            isActive={!hidePrompt}
            mainStyle={{
              background: '#fdfdfd',
              border: '0px',
              height: 'fit-content !important',
              maxHeight: '90%',
            }}
            height={'fit-content'}
            // isAlert={!promptInfo.image}
          >
            {promptInfo.image && (
              <img
                style={{
                  maxHeight: '70vh',
                  maxWidth: '90vw',
                  margin: 'auto',
                  cursor: 'pointer',
                }}
                src={promptInfo.image}
                alt="no-company"
                onClick={() => {
                  promptInfo?.link && window.open(promptInfo.link, '_blank');
                }}
              />
            )}
            {promptInfo.description && (
              <p style={{ margin: '1rem' }}>{promptInfo.description}</p>
            )}
            {!promptInfo.image && promptInfo.link && (
              <Button
                color="green"
                onClick={() => {
                  promptInfo?.link && window.open(promptInfo.link, '_blank');
                }}
              >
                {promptInfo.actionTitle}
              </Button>
            )}
            {!promptInfo.showOnce && (
              <Input
                wrapperStyle={{ margin: '10px' }}
                id={'dontShowThisMessage'}
                type="checkbox"
                label={
                  i18n.t('dontShowThisMessageAgain', {
                    ns: 'general',
                  }) as string
                }
                checked={dontShowThisMessageAgain}
                onChange={(e) => {
                  this.setState({ dontShowThisMessageAgain: e.target.checked });
                }}
              />
            )}
          </Modal>
        )}
        {timeZoneError && !dontShowTimeZoneError && (
          <Modal
            width="unset"
            title={i18n.t('errorInSystemSettigns', { ns: 'general' }) as string}
            onClose={() => {
              if (dontShowTimeZoneError) this.preventPrompt('timeZoneError');
              this.setState({ dontShowTimeZoneError: true });
            }}
            isActive={!dontShowTimeZoneError}
            mainStyle={{
              background: '#fdfdfd',
              border: '0px',
              maxWidth: '95%',
              margin: 'auto',
            }}
          >
            <p style={{ color: red }}>
              <Icon type="clock" style={{ margin: '10px' }} />
              {i18n.t('timeZoneError', { ns: 'general' }) as string}
            </p>
            {
              <Input
                wrapperStyle={{ margin: '10px' }}
                id={'dontShowThisMessage'}
                type="checkbox"
                label={
                  i18n.t('dontShowThisMessageAgain', {
                    ns: 'general',
                  }) as string
                }
                checked={dontShowThisMessageAgain}
                onChange={(e) => {
                  this.setState({ dontShowTimeZoneError: e.target.checked });
                }}
              />
            }
          </Modal>
        )}
        {timeZoneError && !dontShowTimeZoneError && (
          <Modal
            width="unset"
            title={i18n.t('errorInSystemSettigns', { ns: 'general' }) as string}
            onClose={() => {
              if (dontShowTimeZoneError) this.preventPrompt('timeZoneError');
              this.setState({ dontShowTimeZoneError: true });
            }}
            isActive={!dontShowTimeZoneError}
            mainStyle={{
              background: '#fdfdfd',
              border: '0px',
              maxWidth: '95%',
              margin: 'auto',
            }}
          >
            <p style={{ color: red }}>
              <Icon type="clock" style={{ margin: '10px' }} />
              {i18n.t('timeZoneError', { ns: 'general' }) as string}
            </p>
            {
              <Input
                wrapperStyle={{ margin: '10px' }}
                id={'dontShowThisMessage'}
                type="checkbox"
                label={
                  i18n.t('dontShowThisMessageAgain', {
                    ns: 'general',
                  }) as string
                }
                checked={dontShowThisMessageAgain}
                onChange={(e) => {
                  this.setState({ dontShowTimeZoneError: e.target.checked });
                }}
              />
            }
          </Modal>
        )}
        <MainHeader user={user} thisUser={thisUser} />
        <ContentContainer style={{ margin: 0, overflow: 'auto' }}>
          <Helmet>
            <title>{i18n.t('home', { ns: 'general' }) as string}</title>
            <meta
              name="description"
              content={i18n.t('home', { ns: 'general' }) as string}
            />
          </Helmet>
          <Container>
            <Logo>
              <img
                src={logo}
                alt="rastech"
                onClick={() => this.setState({ hidePrompt: false })}
              />
            </Logo>
            {lastFailedLogin && (
              <LoginWarnInfo style={{}}>
                <LogItem
                  level={lastFailedLogin.level}
                  key={lastFailedLogin.id.toString()}
                  className="row"
                >
                  <div
                    className="col s12 m4"
                    style={{
                      float: languageDirection() === 'rtl' ? 'right' : 'left',
                    }}
                  >
                    {logMessages[lastFailedLogin.type]}
                  </div>
                  <div
                    className="col s12 m4"
                    style={{
                      float: languageDirection() === 'rtl' ? 'right' : 'left',
                    }}
                  >
                    {logMessages.date +
                      ': ' +
                      smartDateString(new Date(lastFailedLogin.date), true)}
                  </div>
                  <Button href="/c/profile" color="blue" className="col s4">
                    {i18n.t('showLoginHistory', { ns: 'general' }) as string}
                  </Button>
                </LogItem>
              </LoginWarnInfo>
            )}
            <Contents>
              <AddToHomeScreenPrompt />
              {/*{<Carousel folderId={276424} />}*/}
              <ItemsList>
                {companies.status === 'loading' ? (
                  <span style={{ textAlign: 'center' }}>
                    {i18n.t('fetchData', { ns: 'general' }) as string}
                  </span>
                ) : Object.keys(companies.data).length === 0 ? (
                  <span style={{ textAlign: 'center' }}>
                    <article
                      style={{ display: 'grid', justifyContent: 'center' }}
                    >
                      {this.state.offline ? (
                        <div style={{ margin: 'auto' }}>
                          <p color={red}>
                            <HintIcon type="globe" color={red} />
                            <HintText color={red}>
                              <span>
                                {
                                  i18n.t('errorFetchingData', {
                                    ns: 'general',
                                  }) as string
                                }
                              </span>
                            </HintText>
                          </p>
                        </div>
                      ) : (
                        <p style={{ textAlign: 'center', marginTop: '10px' }}>
                          {(homeDomainProps && homeDomainProps.noCompanyText) ||
                            (i18n.t('youDoNotHaveAnyCompany', {
                              ns: 'general',
                            }) as string)}
                        </p>
                      )}

                      {this.state.offline ? (
                        <Button
                          color={'green-outline'}
                          style={{ width: '250px', margin: 'auto' }}
                          onClick={() => window.location.reload()}
                        >
                          <Icon type={'rotate-ccw'} />
                          {i18n.t('reload', { ns: 'general' }) as string}
                        </Button>
                      ) : (
                        homeDomainProps &&
                        homeDomainProps.noCompanyLink && (
                          <Button
                            style={{ width: '150px', margin: 'auto' }}
                            href={homeDomainProps!.noCompanyLink}
                          >
                            {homeDomainProps!.noCompanyLinkTitle ||
                              (i18n.t('register', { ns: 'general' }) as string)}
                          </Button>
                        )
                      )}
                      <img
                        style={{
                          maxHeight: '80vp',
                          maxWidth: '80vw',
                          margin: 'auto',
                        }}
                        src={image}
                        alt="no-company"
                      />
                    </article>
                  </span>
                ) : (
                  <React.Fragment>
                    {Object.values(companies.data)
                      .sort((a, b) => {
                        if (a.name > b.name) {
                          return 1;
                        }
                        return 0;
                      })
                      .map((company: ICompany, idx) => (
                        <CompanyItem key={idx} space={true}>
                          <CompanyItemHead>
                            <span>{company.name}</span>
                            <span style={{ display: 'flex' }}>
                              {company.mentionCount?.directAddress +
                                company.mentionCount?.info >
                                0 && (
                                <Badge
                                  color={red}
                                  onClick={() =>
                                    navigate(`/t/${company.id}/task#mention`)
                                  }
                                >
                                  {convertDigitToProperFormat(
                                    company.mentionCount?.directAddress +
                                      company.mentionCount?.info
                                  )}
                                </Badge>
                              )}
                              {isCompanyAdmin(this.props.thisUser, company) && (
                                <CompanySettings
                                  to={`/t/${company.id}/admin/project/list`}
                                >
                                  <Icon type="settings" />
                                </CompanySettings>
                              )}
                            </span>
                          </CompanyItemHead>
                          <CompanyItemBody className="row">
                            {company?.projects &&
                              Boolean(
                                Object.keys(company.projects)?.length
                              ) && (
                                <ItemWrapper
                                  key={company.id}
                                  className="col l3 m6 s6"
                                  style={{
                                    float:
                                      languageDirection() === 'rtl'
                                        ? 'right'
                                        : 'left',
                                  }}
                                >
                                  <Item
                                    as={Link as any}
                                    to={`/t/${company.id}/task`}
                                    color={'#F9F9F9;'}
                                  >
                                    <Avatar
                                      src={tasks}
                                      style={{ borderRadius: 0 }}
                                      alt="avatar"
                                    />
                                    <ItemName
                                      color={stringToColour(
                                        i18n.t('tasksList', {
                                          ns: 'general',
                                        }) as string,
                                        1,
                                        undefined,
                                        undefined,
                                        undefined,
                                        undefined,
                                        31,
                                        85
                                      )}
                                    >
                                      {company.configFlag?.tasksSpaceTitle ||
                                        getDomainAndPort().domainFeatures
                                          ?.customTasksName ||
                                        (i18n.t('tasksList', {
                                          ns: 'general',
                                        }) as string)}
                                    </ItemName>
                                  </Item>
                                </ItemWrapper>
                              )}
                            {company.pdpPanels.map((pdpPanel) => (
                              <ItemWrapper
                                key={'pdp' + pdpPanel.id.toString()}
                                className="col l3 m6 s6"
                                style={{
                                  float:
                                    languageDirection() === 'rtl'
                                      ? 'right'
                                      : 'left',
                                }}
                              >
                                <Item
                                  key={pdpPanel.id}
                                  as={Link as any}
                                  to={`/t/${company.id}/pdp/${pdpPanel.id}/terms`}
                                  color={'#F9F9F9;'}
                                >
                                  <Avatar
                                    src={pdp}
                                    style={{ borderRadius: 0 }}
                                    alt="avatar"
                                  />
                                  <ItemName
                                    to={''}
                                    color={stringToColour(
                                      i18n.t('pdpPanelName', {
                                        ns: 'general',
                                      }) as string,
                                      1,
                                      undefined,
                                      undefined,
                                      undefined,
                                      undefined,
                                      31,
                                      85
                                    )}
                                  >
                                    {pdpPanel.properties.name ||
                                      (i18n.t('pdpPanelName', {
                                        ns: 'general',
                                      }) as string)}
                                  </ItemName>
                                </Item>
                              </ItemWrapper>
                            ))}
                            {company.relatedProviders &&
                              Object.keys(company.relatedProviders).length >
                                0 && (
                                <>
                                  {Object.values(company.relatedProviders)
                                    .sort((it) => {
                                      return it.id;
                                    })
                                    .map((companyProvider) => {
                                      const providerId = companyProvider.id;
                                      const providerData =
                                        providers.map[providerId]?.data;
                                      const rootFolderId =
                                        providerData?.rootDocument?.id;

                                      if (providerData?.useVirtualSpaces) {
                                        const items = Object.values(
                                          providers.items[providerId].items
                                        ).filter(
                                          (item: IProviderItemViewWithData) =>
                                            item.data?.dadId === rootFolderId &&
                                            item.data?.type === 'folder' &&
                                            !item.data?.hidden
                                        );
                                        return (
                                          <Fragment key={providerId}>
                                            {Object.values(items)
                                              .sort((a, b) => {
                                                if (
                                                  a.data.order > b.data.order
                                                ) {
                                                  return 1;
                                                } else if (
                                                  a.data.order < b.data.order
                                                ) {
                                                  return -1;
                                                }
                                                return 0;
                                              })
                                              .map((item) => {
                                                const itemId = item.data.id;
                                                const itemThumbUrl =
                                                  item.data.thumbnailUrl;
                                                const itemTitle =
                                                  item.data.name || '';

                                                return (
                                                  <ItemWrapper
                                                    key={
                                                      itemId + '-' + providerId
                                                    }
                                                    className="col l3 m6 s6"
                                                    style={{
                                                      float:
                                                        languageDirection() ===
                                                        'rtl'
                                                          ? 'right'
                                                          : 'left',
                                                    }}
                                                  >
                                                    <Item
                                                      as={Link as any}
                                                      to={`/content/${providerId}/f/${itemId}`}
                                                      color={'#F9F9F9'}
                                                    >
                                                      <Avatar
                                                        src={
                                                          itemThumbUrl
                                                            ? itemThumbUrl
                                                            : folderPanel
                                                        }
                                                        alt="avatar"
                                                      />
                                                      <ItemName
                                                        color={stringToColour(
                                                          itemTitle,
                                                          1,
                                                          undefined,
                                                          undefined,
                                                          undefined,
                                                          undefined,
                                                          31,
                                                          85
                                                        )}
                                                      >
                                                        {itemTitle}
                                                      </ItemName>
                                                    </Item>
                                                  </ItemWrapper>
                                                );
                                              })}
                                          </Fragment>
                                        );
                                      } else {
                                        const providerDocuments =
                                          providerData?.documents;
                                        const profilePicture =
                                          providerDocuments?.find(
                                            (item) =>
                                              item.type === 'document' &&
                                              item.document!.documentType ===
                                                'profile_picture'
                                          );
                                        const itemName =
                                          providers.map[providerId]?.data
                                            ?.name ?? '';
                                        return (
                                          <ItemWrapper
                                            className="col l3  m6 s6"
                                            key={providerId}
                                            style={{
                                              float:
                                                languageDirection() === 'rtl'
                                                  ? 'right'
                                                  : 'left',
                                            }}
                                          >
                                            <Item
                                              as={Link as any}
                                              to={`/content/${providerId}`}
                                              color={'#F9F9F9'}
                                            >
                                              <Avatar
                                                src={
                                                  profilePicture
                                                    ? profilePicture.document
                                                        ?.url
                                                    : folderPanel
                                                }
                                                alt="avatar"
                                              />
                                              <ItemName
                                                color={stringToColour(
                                                  itemName,
                                                  1,
                                                  undefined,
                                                  undefined,
                                                  undefined,
                                                  undefined,
                                                  31,
                                                  85
                                                )}
                                              >
                                                {itemName}
                                              </ItemName>
                                            </Item>
                                          </ItemWrapper>
                                        );
                                      }
                                    })}
                                </>
                              )}
                          </CompanyItemBody>
                        </CompanyItem>
                      ))}
                  </React.Fragment>
                )}
              </ItemsList>
              {hasProvider && !this.state.offline && (
                <Card>
                  <CardHeader>
                    {i18n.t('contentManagement', { ns: 'general' }) as string}
                  </CardHeader>
                  <ItemsList className="row">
                    {providers?.myProvidersStatus === 'loading' ? (
                      <span style={{ textAlign: 'center' }}>
                        {
                          i18n.t('fetchData', {
                            ns: 'general',
                          }) as string
                        }
                      </span>
                    ) : (
                      <React.Fragment>
                        {Object.values(providers.map)
                          .filter((provider) => provider.data?.user === userId)
                          .map((provider) => {
                            const providerData = provider.data!;
                            const providerId = providerData.id;
                            const providerName = providerData.name;
                            const providerDocuments = providerData.documents;
                            const profilePicture = providerDocuments.find(
                              (item) =>
                                item.type === 'document' &&
                                item.document?.documentType ===
                                  'profile_picture'
                            );
                            return (
                              <ItemWrapper
                                key={providerId}
                                className="col m6 s6"
                                style={{
                                  float:
                                    languageDirection() === 'rtl'
                                      ? 'right'
                                      : 'left',
                                }}
                              >
                                <Item
                                  as={Link as any}
                                  to={`/content/${providerId}`}
                                >
                                  <Avatar
                                    src={
                                      profilePicture
                                        ? profilePicture.document?.url
                                        : folderPanel
                                    }
                                    alt="avatar"
                                  />
                                  <ItemName>
                                    {providerName
                                      ? providerName
                                      : (i18n.t('noName', {
                                          ns: 'general',
                                        }) as string)}
                                  </ItemName>
                                </Item>
                              </ItemWrapper>
                            );
                          })}
                      </React.Fragment>
                    )}
                  </ItemsList>
                </Card>
              )}
            </Contents>
          </Container>
          {/*<NotificationAccessAlert />*/}
        </ContentContainer>
      </LayoutContainer>
    );
  }
}

const mapStateToProps: MapStateToProps<StateToProps, OwnProps, RootState> = (
  state
) => {
  const thisUser = state.thisUser;
  const userId = Number(thisUser.userId);
  const user = state.users.map[userId];
  const companies = state.companies;
  const providers = state.providers;

  return { userId, companies, providers, user, thisUser, state };
};

const mapDispatchToProps: MapDispatchToProps<
  DispatchToProps,
  OwnProps
> = () => {
  return {
    getMyCompanies: () => appDispatch(getMyCompanies({})),
    getMyProviders: () => appDispatch(getMyProviders({})),
    getCompanyManagers: (companyId: number) =>
      appDispatch(getCompanyManagers({ companyId })),
    getDocumentsInFolder: (folderId: number, providerId) =>
      appDispatch(requireDocumentInFolder({ folderId, providerId })),
  };
};

export default protectedRoute(
  connect(mapStateToProps, mapDispatchToProps)(oldHomePage)
);
